import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import { Logo } from "../components/Logo";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      sessionStorage.setItem("tp-admin-csrf", r.data.csrf_token);
      sessionStorage.setItem("tp-admin-email", r.data.email);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const status = err?.response?.status;
      toast.error(status === 429 ? "Too many attempts. Please try again later." : "Invalid credentials");
    } finally { setLoading(false); }
  };

  const inputCls = "w-full bg-[#0B1228] border border-white/10 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-white rounded-lg px-4 py-3 text-sm placeholder:text-slate-500 outline-none";

  return (
    <main className="min-h-screen flex items-center justify-center px-6 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo /></div>
        <div className="glass-strong rounded-2xl p-8">
          <div className="flex items-center gap-2 mb-1 text-cyan-300">
            <Lock size={16} /><span className="eyebrow">SECURE LOGIN</span>
          </div>
          <h1 className="font-display font-bold text-2xl text-white mb-6">{t.admin.loginTitle}</h1>
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="admin-email" required type="email" className={inputCls} placeholder={t.admin.email} value={email} onChange={(e) => setEmail(e.target.value)} />
            <input data-testid="admin-password" required type="password" className={inputCls} placeholder={t.admin.password} value={password} onChange={(e) => setPassword(e.target.value)} />
            <button data-testid="admin-login-btn" type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 disabled:opacity-60 text-white font-semibold py-3 rounded-lg shadow-[0_0_20px_rgba(37,99,235,0.4)]">
              {loading && <Loader2 size={16} className="animate-spin" />}{t.admin.signIn}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
